const data1 = {
    "viewer": {
      "cancers": [
        {
          "value": "lung",
          "label": "肺癌",
          "name_en": "Lung Cancer"
        },
        {
          "value": "oral",
          "label": "口腔癌",
          "name_en": "Oral Cancer"
        },
        {
          "value": "breast",
          "label": "乳癌",
          "name_en": "Breast Cancer"
        },
        {
          "value": "colo_rectal",
          "label": "結腸癌",
          "name_en": "Colo Rectal Cancer"
        },
        {
          "value": "prostate",
          "label": "前列腺癌",
          "name_en": "Prostate Cancer"
        },
        {
          "value": "thyroid",
          "label": "甲狀腺癌",
          "name_en": "Thyroid Cancer"
        },
        {
          "value": "npc",
          "label": "鼻咽癌",
          "name_en": "Nasopharynx Cancer"
        }
      ]
    }
}

const data2 = [
    {
      "ht": 0,
      "rt": 0,
      "survival": [
        1,
        0.997878200098352,
        0.9931954436935854,
        0.9857516575472434,
        0.9772753963479379,
        0.90,
        0.9617840039916887,
        0.9541170775760099,
        0.9490268589109127,
        0.9424891777909009,
        0.9363316702219724
      ],
      "herceptin": 0,
      "ct": 0
    },
    {
      "ht": 0,
      "rt": 0,
      "survival": [
        1,
        0.997878200098352,
        0.9931954436935854,
        0.9857516575472434,
        0.9772753963479379,
        0.90,
        0.9617840039916887,
        0.9541170775760099,
        0.9490268589109127,
        0.9424891777909009,
        0.9363316702219724
      ],
      "herceptin": 1,
      "ct": 0
    },
    {
      "ht": 1,
      "rt": 0,
      "survival": [
        1,
        0.9983586520024622,
        0.9947334377201964,
        0.9889627518136003,
        0.9823796141281034,
        0.9753969865297575,
        0.9703145665798732,
        0.9643271229409968,
        0.9603459234843019,
        0.9552255162040978,
        0.9503955010348655
      ],
      "herceptin": 0,
      "ct": 0
    },
    {
      "ht": 1,
      "rt": 0,
      "survival": [
        1,
        0.9983586520024622,
        0.9947334377201964,
        0.9889627518136003,
        0.9823796141281034,
        0.90,
        0.9703145665798732,
        0.9643271229409968,
        0.9603459234843019,
        0.9552255162040978,
        0.9503955010348655
      ],
      "herceptin": 1,
      "ct": 0
    },
    {
      "ht": 0,
      "rt": 1,
      "survival": [
        1,
        0.9983133169898556,
        0.9945882439212158,
        0.9886593755394256,
        0.9818969529770374,
        0.9747255299370844,
        0.9695065839151275,
        0.9633592728225534,
        0.9592723571336045,
        0.9540166720456683,
        0.9490597647215345
      ],
      "herceptin": 0,
      "ct": 0
    },
    {
      "ht": 0,
      "rt": 1,
      "survival": [
        1,
        0.9983133169898556,
        0.9945882439212158,
        0.9886593755394256,
        0.9818969529770374,
        0.9747255299370844,
        0.9695065839151275,
        0.9633592728225534,
        0.9592723571336045,
        0.9540166720456683,
        0.9490597647215345
      ],
      "herceptin": 1,
      "ct": 0
    },
    {
      "ht": 1,
      "rt": 1,
      "survival": [
        1,
        0.9986953071750976,
        0.9958120953101726,
        0.9912180888246216,
        0.9859705700734581,
        0.9803967175089058,
        0.90,
        0.9715434222564804,
        0.9683543053126589,
        0.964248639636949,
        0.9603716755358569
      ],
      "herceptin": 0,
      "ct": 0
    },
    {
      "ht": 1,
      "rt": 1,
      "survival": [
        1,
        0.9986953071750976,
        0.9958120953101726,
        0.9912180888246216,
        0.9859705700734581,
        0.9803967175089058,
        0.9763345479395864,
        0.9715434222564804,
        0.9683543053126589,
        0.964248639636949,
        0.9603716755358569
      ],
      "herceptin": 1,
      "ct": 0
    },
    {
      "ht": 0,
      "rt": 0,
      "survival": [
        1,
        0.9984951252301706,
        0.9951706067228479,
        0.9898764925091073,
        0.9838338822711198,
        0.9774208994882251,
        0.9727507036449506,
        0.9672462757284481,
        0.9635846720189994,
        0.9588734537573933,
        0.9544274951645864
      ],
      "herceptin": 0,
      "ct": 1
    },
    {
      "ht": 0,
      "rt": 0,
      "survival": [
        1,
        0.9984951252301706,
        0.9951706067228479,
        0.9898764925091073,
        0.9838338822711198,
        0.9774208994882251,
        0.9727507036449506,
        0.9672462757284481,
        0.9635846720189994,
        0.9588734537573933,
        0.9544274951645864
      ],
      "herceptin": 1,
      "ct": 1
    },
    {
      "ht": 1,
      "rt": 0,
      "survival": [
        1,
        0.9988359645470454,
        0.9962630061189215,
        0.9921616847217696,
        0.9874744271100331,
        0.90,
        0.9788601914397884,
        0.9745736988870866,
        0.9717192172636399,
        0.9680428668200465,
        0.9645697530968028
      ],
      "herceptin": 0,
      "ct": 1
    },
    {
      "ht": 1,
      "rt": 0,
      "survival": [
        1,
        0.9988359645470454,
        0.9962630061189215,
        0.9921616847217696,
        0.9874744271100331,
        0.9824927288594955,
        0.9788601914397884,
        0.9745736988870866,
        0.90,
        0.9680428668200465,
        0.9645697530968028
      ],
      "herceptin": 1,
      "ct": 1
    },
    {
      "ht": 0,
      "rt": 1,
      "survival": [
        1,
        0.9988038052930948,
        0.9961598995467771,
        0.9919458778425013,
        0.9871304087043109,
        0.9820131377166849,
        0.978282195805778,
        0.9738800756724489,
        0.9709488915114668,
        0.9671741049399029,
        0.9636083608457684
      ],
      "herceptin": 0,
      "ct": 1
    },
    {
      "ht": 0,
      "rt": 1,
      "survival": [
        1,
        0.9988038052930948,
        0.9961598995467771,
        0.9919458778425013,
        0.90,
        0.9820131377166849,
        0.978282195805778,
        0.9738800756724489,
        0.9709488915114668,
        0.9671741049399029,
        0.9636083608457684
      ],
      "herceptin": 1,
      "ct": 1
    },
    {
      "ht": 1,
      "rt": 1,
      "survival": [
        1,
        0.9990747640085288,
        0.9970288569220672,
        0.9937654165867893,
        0.9900323514951419,
        0.9860607963547632,
        0.983162225983992,
        0.90,
        0.977457663299791,
        0.9745174602878449,
        0.9717376922872905
      ],
      "herceptin": 0,
      "ct": 1
    },
    {
      "ht": 1,
      "rt": 1,
      "survival": [
        1,
        0.9990747640085288,
        0.9970288569220672,
        0.9937654165867893,
        0.9900323514951419,
        0.9860607963547632,
        0.983162225983992,
        0.9797389929241413,
        0.977457663299791,
        0.9745174602878449,
        0.90
      ],
      "herceptin": 1,
      "ct": 1
    }
]


export {data1, data2}


// WEBPACK FOOTER //
// ./src/store/fakeData.js